import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface AnalyticsServiceInterface {
  sendEvents(events: any[], category?: 'ab-test' | 'user-journey'): Observable<any>;
  sendEventImmediate(event: any, category?: 'ab-test' | 'user-journey'): Observable<any>;
  isServiceAvailable(): Observable<boolean>;
}

export const ANALYTICS_SERVICE_TOKEN = new InjectionToken<AnalyticsServiceInterface>('AnalyticsService');
